import { createStore, compose, applyMiddleware } from "redux";
import reducer from "./reducers"; // Gets the State from the reducer(s)
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducer);

// let store = createStore(reducer, compose(applyMiddleware(thunk))); // Creates the store from the State received from the reducer(s)

// export default store;

export default () => {
  let store = createStore(persistedReducer, compose(applyMiddleware(thunk))); // Creates the store from the State received from the reducer(s)
  let persistor = persistStore(store);
  return { store, persistor };
};
